import './Badge.scss';

type Props = {
  badgeText: string;
  className?: string;
  badgeIcon?: React.ReactNode;
};

export const Badge = ({ badgeText, className, badgeIcon }: Props) => {
  return (
    <div className={`badge ${className ?? ''}`.trim()}>
      {badgeIcon && <span className='badge-icon'>{badgeIcon}</span>}
      <span>{badgeText}</span>
    </div>
  );
};
